import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useState } from "react"

const estilosBotoes = require('../../estilos/botoes.module.scss').default
const estilosAlterarSenhaVendedor = require('./alterar-senha-vendedor.module.scss').default
const estilosInputs = require('../../estilos/inputs.module.scss').default
import clsx from 'clsx'

export type AlterarSenhaVendedorProps = {
    onNovaSenhaInformada: (senhaAtual:string, novaSenha: string, confirmacaoSenha:string) => void
    onCancelar: () => void
}

export const AlterarSenhaVendedor = (props: AlterarSenhaVendedorProps) => {

    const [senhaAtual, setSenhaAtual] = useState("")
    const [novaSenha, setNovaSenha] = useState("")
    const [confirmacaoSenha, setConfirmacaoSenha] = useState("")

    return <div className={estilosAlterarSenhaVendedor.container}>
        <div className="_flex _justify-around _border-b _border-gray-100 _pb-4">
            <div >
                Alteração de senha do vendedor
            </div>
            <div>
                <FontAwesomeIcon icon={faTimes} className="_cursor-pointer"
                    onClick={() => props.onCancelar()}/>
            </div>
        </div>

        <div className="_flex _flex-row _justify-between _gap-2 _ml-8 _mt-8">
            <div className={clsx("_flex _flex-col _gap-2 _pl-4 _pr-4 _justify-center _justify-items-center", estilosAlterarSenhaVendedor.containerLegenda)}>
                
            </div>

            <div className="_flex _flex-col _gap-4">
                
                
                
            </div>
        </div>

        <div className={clsx("_grid _grid-rows-3 _grid-cols-2 _gap-x-4", estilosAlterarSenhaVendedor.corpo)}>
            <div className={estilosAlterarSenhaVendedor.legenda}>Senha atual</div>
            <input className={estilosInputs.inputPadrao}
                onChange={e => setSenhaAtual(e.target.value)}
                autoComplete="off"
                aria-autocomplete="none"
                name="data-password" 
                type="password"/>

            <div className={estilosAlterarSenhaVendedor.legenda}>Nova senha</div>
            <input className={estilosInputs.inputPadrao}
                onChange={e => setNovaSenha(e.target.value)}
                autoComplete="off"
                aria-autocomplete="none"
                name="data-password" 
                type="password"/>

            <div className={estilosAlterarSenhaVendedor.legenda}>Confirmação</div>
            <input className={estilosInputs.inputPadrao}
                onChange={e => setConfirmacaoSenha(e.target.value)}
                autoComplete="off"
                aria-autocomplete="none"
                name="data-password" 
                type="password"/>
        </div>
        

        <div className="_flex _justify-end _gap-4 _ml-8 _mt-8 _border-t _border-gray-100 _pt-4">
            <button className={estilosBotoes.botaoPrimario}
                onClick={() => props.onNovaSenhaInformada(senhaAtual, novaSenha, confirmacaoSenha)}>OK</button>
            <button className={estilosBotoes.botaoPrimario}
                onClick={() => props.onCancelar()}>Cancelar</button>
        </div>
    </div>
}